module.exports = (currentdata, newdata, id, deletestatus) => {
  newdata = Array.isArray(newdata) ? newdata : [newdata];
  newdata.map(entry => {
    // console.log('combine service', currentdata, 'entry', entry)
    let index = currentdata.findIndex(invce => invce[id] === entry[id]);
    if (index > -1) {
      if (deletestatus) {
        currentdata.splice(index, 1);
      } else {
        currentdata[index] = entry;
      }
    } else {
      currentdata = currentdata.concat(entry);
    }
  });
  return currentdata;
};



// WEBPACK FOOTER //
// ./src/services/combine-service.js